var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.9795143 9.35389838 5.6976167 5.85425052c.4304624.4418917.4304624 1.1431201.0001773 1.5848298l-5.6934388 5.8499068c-.2837547.2982289-.7070243.4220416-1.1082921.3241919-.4012677-.0978498-.7186225-.4022648-.8309639-.7970824s-.0023365-.819122.283763-1.1066571l4.9272735-5.062691-4.9217383-5.0570678c-.3293481-.3289362-.4251241-.8232239-.2422111-1.25002145.1829088-.42678783.608016-.70097341 1.0750748-.69340485.3105108.00501358.6057297.13472372.8127389.35374558z"}));
}

ChevronRight.defaultProps = {"height":"32","viewBox":"0 0 32 32","width":"32"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
